import { forwardRef } from 'react';

import type { ReactNode } from 'react';

import styles from './Flyout.module.css';

interface FlyoutProps {
  position: { top: number; left: number };
  visible: boolean;
  children: ReactNode;
}

export const Flyout = forwardRef<HTMLDivElement, FlyoutProps>(
  ({ position, visible, children }: FlyoutProps, ref) =>
    visible && (
      <div className={styles['flyout__wrapper']} style={{ top: position.top, left: position.left }} ref={ref}>
        {children}
      </div>
    )
);
